var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('v-text-field',{attrs:{"append-icon":_vm.mdiMagnify,"placeholder":_vm.$t('msgs.placeholderSearchBar')},on:{"click:append":_vm.onSubmit},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }